import React, { useState, useEffect, useRef, useCallback } from 'react';
import ManagementCommittee from './ManagementCommittee';
import Founder from './Founder ';

const Tabs = () => {
    const [activeTab, setActiveTab] = useState('management-committee');
    const underlineRef = useRef(null);
    const navTabsRef = useRef([]);

    // Memoized function to prevent re-creation
    const updateUnderline = useCallback(() => {
        const activeTabElement = navTabsRef.current.find(tab => tab.dataset.target === activeTab);
        if (activeTabElement && underlineRef.current) {
            underlineRef.current.style.width = `${activeTabElement.offsetWidth}px`;
            underlineRef.current.style.left = `${activeTabElement.offsetLeft}px`;
        }
    }, [activeTab]);

    useEffect(() => {
        updateUnderline();
        window.addEventListener('resize', updateUnderline);
        return () => window.removeEventListener('resize', updateUnderline);
    }, [updateUnderline]); // ✅ Dependency added

    useEffect(() => {
        updateUnderline();
        scrollToTop();
    }, [updateUnderline]); // ✅ Dependency added

    const handleTabClick = (tab) => setActiveTab(tab);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <div>
            {/* Tab Navigation */}
            <div className='container mt-5 pt-5'>
                <h5>Management Committe</h5>
                {/* <div className='row pt-5'>
                    <div className='col-md-6 me-auto'>
                        <div className="navtabs">
                            {[
                                { key: "management-committee", label: "Management Committee" },
                                { key: "founder-pastmembers", label: "Founder & Past Members" }
                            ].map((tab, index) => (
                                <div
                                    key={tab.key}
                                    ref={el => navTabsRef.current[index] = el}
                                    className={`navtab ${activeTab === tab.key ? 'active' : ''}`}
                                    data-target={tab.key}
                                    onClick={() => handleTabClick(tab.key)}
                                >
                                    {tab.label}
                                </div>
                            ))}
                            <div className="underline" ref={underlineRef}></div>
                        </div>
                    </div>
                </div> */}
            </div>

            {/* Tab Content */}
            <div className='container'>
                <div className='row'>
                    {/* <div className={`content ${activeTab === 'management-committee' ? 'active' : ''}`}> */}
                        <div className="tab-Scroll p-4 mt-4">
                            <ManagementCommittee />
                        </div>
                    {/* </div>
                    <div className={`content ${activeTab === 'founder-pastmembers' ? 'active' : ''}`}>
                        <div className="tab-Scroll p-4 mt-4">
                            <Founder />
                        </div>
                    </div> */}
                </div>
            </div>


        </div>
    );
};

export default Tabs;
